module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('AppTemplate', {
    attrs: {
      "pagetitle": "地域分析",
      "tip": "地域分析报告帮助您了解您账户整体推广的地域分布情况，您可以根据不同地域的表现结合自身应用推广战略目标，优化推广策略",
      "currentTab": _vm.currentTab,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sum": _vm.sum,
      "yAxis": _vm.yAxis,
      "legend": _vm.legend,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "tableUpdate": _vm.getTableData,
      "clearKeyword": _vm.clearKeyword,
      "tablesorter": _vm.tablesorter
    }
  }, [_c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab
    }
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    },
    slot: "extentTab"
  }) : _vm._e(), _c('div', {
    slot: "common"
  }, [_c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")]), _c('Search', {
    attrs: {
      "placeholder": _vm.placeHolder,
      "defaultValue": _vm.keyword
    },
    on: {
      "doSearch": _vm.doSearch
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17457361", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17457361!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/app/region.vue
// module id = 717
// module chunks = 0